module.exports = __webpack_public_path__ + "img/consult_info1.7442fef7.png";